var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Subheader } from './Drawer.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
var VERSION = '4.1.0';
var DrawerSubheader = function (_a) {
    var automationId = _a.automationId, children = _a.children, _b = _a.__TYPE, TYPE = _b === void 0 ? 'DrawerSubheader' : _b, other = __rest(_a, ["automationId", "children", "__TYPE"]);
    return (React.createElement(Subheader, __assign({}, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION)), React.isValidElement(children) ? React.cloneElement(children) : children));
};
DrawerSubheader.defaultProps = {
    __TYPE: 'DrawerSubheader',
};
export default DrawerSubheader;
